module.exports = __webpack_public_path__ + "img/b-icon_disable.192c6574.svg";